import { captureDuration } from 'hooks/business/im/qaPairTimestamp';
import {
  useClearKnowledgeQuery,
  useKnowledgeQueryCount,
} from 'hooks/business/im/useKnowledgeQuery';
import { logger } from 'services/logger';
import { useAuthorization } from 'components/Authorization';
import {
  QuitCreateSupplementKnowledgeParams,
  quitCreateSupplementKnowledge,
} from 'services/api/supplementKnowledge';
import {
  useCurrentQAPairKnowledgeQuery,
  useQAPairOpenedWithKeepAlive,
} from 'hooks/business/im/useQAPair';
import { isIdEqual } from 'utils/is';

interface QuitQAPairParams {
  conversation: Conversation.Conversation;
  isLeaveConversation?: boolean;
  extra?: QuitCreateSupplementKnowledgeParams['extra'];
}

export const useQuitQAPair = () => {
  const { payload } = useAuthorization<Oversea.Token.Payload>();
  const clearKnowledgeQuery = useClearKnowledgeQuery();
  const { getKnowledgeQueryCount } = useKnowledgeQueryCount();
  const qaPairOpenedWithKeepAlive = useQAPairOpenedWithKeepAlive();
  const currentQAPairKnowledgeQuery = useCurrentQAPairKnowledgeQuery();

  const fetchQuitQAPair = async ({
    conversation,
    isLeaveConversation,
    extra,
  }: QuitQAPairParams) => {
    const { conversationId } = conversation;
    if (
      !currentQAPairKnowledgeQuery ||
      !isIdEqual(conversationId, currentQAPairKnowledgeQuery.conversationId)
    ) {
      return;
    }

    const query_msg_id = currentQAPairKnowledgeQuery.msgId;
    if (query_msg_id && payload?.id) {
      const cancelCount = await getKnowledgeQueryCount(conversationId);
      logger.info(
        `[ConfirmModal]quitCreateSupplementKnowledge conversationId:${conversationId} queryMsgId:${query_msg_id} impressions:${cancelCount}`,
      );
      captureDuration(conversationId, '$qaPairQuitDuration', true);
      await quitCreateSupplementKnowledge({
        query_msg_id: query_msg_id,
        popup_times: cancelCount,
        assistant_id: payload.id,
        timestamp: Date.now(),
        extra,
      });

      if (isLeaveConversation && qaPairOpenedWithKeepAlive) {
        return;
      }

      if (cancelCount >= 3) {
        await clearKnowledgeQuery(conversationId);
      }
    }
  };

  return fetchQuitQAPair;
};
